import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Input from '@welldev-group/rcl-input';
import Button from '@welldev-group/rcl-button';
import { I18nText } from '@welldev-group/react-comp-lib';
import Alert from '@welldev-group/rcl-alert';
import PhoneNumberInput from '../../../shared/components/PhoneNumberInput';
import isEmailValid from '../../../shared/helper/isEmailValid';
import CountrySelector from './CountrySelector';

const AddNewCreditCard = props => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [phoneCountryCode, setPhoneCountryCode] = useState('');
  const [city, setCity] = useState('');
  const [line1, setLine1] = useState('');
  const [line2, setLine2] = useState('');
  const [postalCode, setPostalCode] = useState('');
  const [state, setState] = useState('');
  const [country, setCountry] = useState('');

  const [formError, setFormError] = useState({});

  const [step, setStep] = useState(1);
  const [submittedOnce, setSubmittedOnce] = useState(false);

  const [ccvError, setCcvError] = useState(false);
  const [ccvErrorType, setCcvErrorType] = useState(null);
  const [hideSubmitButton, setHideSubmitButton] = useState(false);
  const [showChallenge, setShowChallenge] = useState(false);
  const WellDevCreditCard = window.WellDevCreditCard;
  const customStyles = {
    base: {
      background: '#fff',
      border: '1px solid #dbe2f1',
      'border-radius': '3px',
      'box-shadow': '0 1px 3px rgb(75 115 167 / 16%)',
      'box-sizing': 'border-box',
      color: '#182146',
      'font-size': '14px',
      height: '35px',
      padding: '10px 12px',
      width: '100%',
      'margin-bottom': '20px',
    },
    base_select: {
      border: '1px solid #dbe2f1',
      'border-radius': '3px',
      'box-shadow': '0 1px 3px rgb(75 115 167 / 16%)',
      'box-sizing': 'border-box',
      color: '#182146',
      'font-size': '14px',
      height: '35px',
      padding: '8px 15px',
      width: '100%',
      'margin-bottom': '20px',
    },
    submit_button: {
      'align-items': 'center',
      background: '#c44a47',
      'border-radius': '3px',
      border: '1px solid #e2e8f1',
      'box-sizing': 'border-box',
      color: '#fff',
      cursor: 'pointer',
      display: 'inline-flex',
      'font-family': 'Roboto,sans-serif',
      'font-size': '14px',
      'font-weight': '400',
      'justify-content': 'center',
      'line-height': '18px',
      padding: '6px 12px',
      'text-align': 'center',
      'text-decoration': 'none',
      'white-space': 'nowrap',
    },
    submit_button_hover: {
      'align-items': 'center',
      background: '#c44a47',
      'border-radius': '3px',
      border: '1px solid #e2e8f1',
      'box-sizing': 'border-box',
      'box-shadow': '0 3px 10px rgb(75 115 167 / 24%)',
      color: '#fff',
      cursor: 'pointer',
      display: 'inline-flex',
      'font-family': 'Roboto,sans-serif',
      'font-size': '14px',
      'font-weight': '400',
      'justify-content': 'center',
      'line-height': '18px',
      padding: '6px 12px',
      'text-align': 'center',
      'text-decoration': 'none',
      'white-space': 'nowrap',
    },
    submit_button_active: {
      'align-items': 'center',
      background: '#c44a47',
      'border-radius': '3px',
      border: '1px solid #e2e8f1',
      'box-sizing': 'border-box',
      'box-shadow': '0 3px 10px rgb(75 115 167 / 24%)',
      color: '#fff',
      cursor: 'pointer',
      display: 'inline-flex',
      'font-family': 'Roboto,sans-serif',
      'font-size': '14px',
      'font-weight': '400',
      'justify-content': 'center',
      'line-height': '18px',
      padding: '6px 12px',
      'text-align': 'center',
      'text-decoration': 'none',
      'white-space': 'nowrap',
    },
    submit_button_disabled: {
      'align-items': 'center',
      background: '#c44a47',
      'border-radius': '3px',
      border: '1px solid #e2e8f1',
      'box-sizing': 'border-box',
      color: '#fff',
      cursor: 'pointer',
      display: 'inline-flex',
      'font-family': 'Roboto,sans-serif',
      'font-size': '14px',
      'font-weight': '400',
      'justify-content': 'center',
      'line-height': '18px',
      opacity: '0.4',
      'pointer-events': 'none',
      padding: '6px 12px',
      'text-align': 'center',
      'text-decoration': 'none',
      'white-space': 'nowrap',
    },
    credit_card_form__row: {
      'align-items': 'center',
      display: 'flex',
    },
    credit_card_form__field_left: {
      'padding-right': '10px',
      width: '50%',
    },
    credit_card_form__field_right: {
      'padding-left': '10px',
      width: '50%',
    },
    invalid: {
      'border-color': '#ff5555',
      'margin-top': '6px',
    },
    three_ds_iframe: {
      width: '400px',
      height: '666px',
      'border-radius': '3px',
      border: '1px solid #e2e8f1',
      margin: '6px auto auto',
    },
    three_ds_container: {
      display: 'flex',
    },
  };

  const creditCardTokenHandler = data => {
    if (data && data.status === 'stripe.authentication.succeeded') {
      setCcvError(false);
      setCcvErrorType(null);
      props.fetchCreditCards();
      props.closeModal();
    } else if (
      data &&
      data.status === 'stripe.authentication.requires_payment_method'
    ) {
      setCcvError(true);
      setCcvErrorType('three_ds_failed');
    } else if (data && data.status === 'stripe.authentication.failed') {
      setCcvError(true);
      setCcvErrorType('three_ds_not_supported');
    } else if (
      data &&
      data.status === 'stripe.authentication.requires_action'
    ) {
      setHideSubmitButton(true);
      setShowChallenge(true);
    }
  };

  const billingDetails = {
    address: {
      city,
      country,
      line1,
      line2,
      postalCode,
      state,
    },
    email,
    name,
    phone,
  };

  let content;

  const getEmailError = email => {
    if (email.length === 0) {
      return I18n.t('components.billing.add_credit_card.fields.error');
    }

    if (!isEmailValid(email)) {
      return I18n.t('components.billing.add_credit_card.fields.invalid_email');
    }

    return '';
  };

  const getGeneralError = (...formInputs) =>
    formInputs.every(Boolean)
      ? ''
      : I18n.t('components.billing.add_credit_card.fields.error');

  const getFormError = () => ({
    name: getGeneralError(name),
    email: getEmailError(email),
    country: getGeneralError(country),
    city: getGeneralError(city),
    line1: getGeneralError(line1),
    postalCode: getGeneralError(postalCode),
    phone: getGeneralError(phone, phoneCountryCode),
  });

  const hasError = error => {
    const errorValues = Object.values(error);

    return errorValues.some(Boolean);
  };

  const onSubmitBillingForm = () => {
    setSubmittedOnce(true);

    const newFormError = getFormError();
    setFormError(newFormError);

    if (!hasError(newFormError)) {
      setStep(2);
    }
  };

  useEffect(() => {
    if (submittedOnce) {
      setFormError(getFormError());
    }
  }, [name, email, phone, country, phoneCountryCode, city, line1, postalCode]);

  if (WellDevCreditCard === null) {
    content = <h3>{I18n.t('components.billing.add_credit_card.error')}</h3>;
  } else if (step === 1) {
    content = (
      <div className="credit-card-details__billing-form col-grid direction-column">
        <div className="col-6 col-bleed-x credit-card-details__billing-form-title">
          {I18n.t('components.billing.add_credit_card.step1')}
        </div>
        <div className="col-12 col-bleed credit-card-details__billing-form-info">
          {I18n.t('components.billing.add_credit_card.step1_info')}
        </div>
        <div className="credit-card-details__billing-form-row">
          <div className="credit-card-details__billing-form-field-left col-xs-12 col-sm-6 col-bleed">
            <Input
              size="small"
              label={I18n.t('components.billing.add_credit_card.fields.name')}
              value={name}
              onChange={value => setName(value)}
              error={formError.name}
              touched={true}
              required={true}
              placeholder={I18n.t(
                'components.billing.add_credit_card.placeholders.name',
              )}
            />
          </div>
          <div className="credit-card-details__billing-form-field-right col-xs-12 col-sm-6 col-bleed">
            <Input
              size="small"
              label={I18n.t('components.billing.add_credit_card.fields.email')}
              value={email}
              onChange={value => setEmail(value)}
              error={formError.email}
              touched={true}
              required={true}
              placeholder={I18n.t(
                'components.billing.add_credit_card.placeholders.email',
              )}
            />
          </div>
        </div>
        <div className="col-bleed col-grid direction-row align-center credit-card-details__billing-form-row">
          <div className="credit-card-details__billing-form-field-left col-xs-12 col-sm-6 col-6 col-bleed">
            <PhoneNumberInput
              isRequired={true}
              onChange={inputParam => setPhone(inputParam)}
              onCountryCodeChange={setPhoneCountryCode}
              error={formError.phone}
              isInputTouched={true}
            />
          </div>
        </div>
        <div className="credit-card-details__billing-form-row">
          <div className="credit-card-details__billing-form-field-left col-xs-12 col-sm-6 col-bleed">
            <Input
              size="small"
              label={I18n.t('components.billing.add_credit_card.fields.line1')}
              value={line1}
              onChange={value => setLine1(value)}
              touched={true}
              error={formError.line1}
              required={true}
              placeholder={I18n.t(
                'components.billing.add_credit_card.placeholders.line1',
              )}
            />
          </div>
          <div className="credit-card-details__billing-form-field-right col-xs-12 col-sm-6 col-bleed">
            <Input
              size="small"
              label={I18n.t('components.billing.add_credit_card.fields.line2')}
              value={line2}
              onChange={value => setLine2(value)}
              placeholder={I18n.t(
                'components.billing.add_credit_card.placeholders.line2',
              )}
            />
          </div>
        </div>
        <div className="credit-card-details__billing-form-row">
          <div className="credit-card-details__billing-form-field-left col-xs-12 col-sm-6 col-bleed">
            <Input
              size="small"
              label={I18n.t(
                'components.billing.add_credit_card.fields.postal_code',
              )}
              value={postalCode}
              onChange={value => setPostalCode(value)}
              error={formError.postalCode}
              touched={true}
              required={true}
              placeholder={I18n.t(
                'components.billing.add_credit_card.placeholders.postal_code',
              )}
            />
          </div>
          <div className="credit-card-details__billing-form-field-right col-xs-12 col-sm-6 col-bleed">
            <Input
              size="small"
              label={I18n.t('components.billing.add_credit_card.fields.city')}
              value={city}
              onChange={value => setCity(value)}
              error={formError.city}
              touched={true}
              required={true}
              placeholder={I18n.t(
                'components.billing.add_credit_card.placeholders.city',
              )}
            />
          </div>
        </div>
        <div className="credit-card-details__billing-form-row">
          <div className="credit-card-details__billing-form-field-left col-xs-12 col-sm-6 col-bleed">
            <Input
              size="small"
              label={I18n.t('components.billing.add_credit_card.fields.state')}
              value={state}
              onChange={value => setState(value)}
              placeholder={I18n.t(
                'components.billing.add_credit_card.placeholders.state',
              )}
            />
          </div>
          <div className="credit-card-details__billing-form-field-right col-xs-12 col-sm-6 col-bleed">
            <CountrySelector
              title={I18n.t(
                'components.billing.add_credit_card.fields.country',
              )}
              required={true}
              onChange={setCountry}
              value={country}
              error={formError.country}
              touched={true}
              placeholder={I18n.t(
                'components.billing.add_credit_card.placeholders.country',
              )}
              menuPlacement="top"
              maxMenuHeight={220}
            />
          </div>
        </div>
        <div className="col-grid col-bleed direction-row align-center">
          <div className="credit-card-details__billing-form-submit-button">
            <Button
              size="small"
              version="v2"
              className=""
              label={I18n.t('components.billing.add_credit_card.submit')}
              primary={true}
              onClick={onSubmitBillingForm}
            />
          </div>

          <Button
            size="small"
            version="v2"
            className=""
            label={I18n.t('components.billing.add_credit_card.cancel')}
            primary={false}
            onClick={props.closeModal}
          />
        </div>
      </div>
    );
  } else if (step === 2) {
    content = (
      <div className="credit-card-details__billing-form col-grid direction-column">
        <div className="col-6 col-bleed-x credit-card-details__billing-form-title">
          {!showChallenge && I18n.t('components.billing.add_credit_card.step2')}
          {showChallenge &&
            I18n.t('components.billing.add_credit_card.step2_test')}
        </div>
        <div className="col-5 col-bleed credit-card-details__billing-form-info">
          {!showChallenge &&
            I18n.t('components.billing.add_credit_card.step2_info')}
          {showChallenge &&
            I18n.t('components.billing.add_credit_card.step2_test_info')}
        </div>
        <Alert
          className="credit-card-details--add-bottom-margin"
          isVisible={!showChallenge}
          type="warning"
          hideClose={true}
        >
          <I18nText id="billing.add_credit_card.step2_notice_html" />
        </Alert>
        <Alert
          className="credit-card-details credit-card-details--add-bottom-margin"
          isVisible={ccvError && ccvErrorType === 'three_ds_not_supported'}
          type="danger"
          hideClose={true}
        >
          {I18n.t('stripe.error_message.three_ds_not_supported')}
        </Alert>
        <Alert
          className="credit-card-details credit-card-details--add-bottom-margin"
          isVisible={ccvError && ccvErrorType === 'three_ds_failed'}
          type="danger"
          hideClose={true}
        >
          {I18n.t('stripe.error_message.three_ds_failed')}
        </Alert>
        <WellDevCreditCard
          iframeBaseURL={props.ccvUrl}
          iframeHostURL={window.location.origin}
          apiToken={props.ccvPublicToken}
          handler={creditCardTokenHandler}
          submitText={I18n.t('components.billing.add_credit_card.submit')}
          styles={customStyles}
          iframeHeight={showChallenge ? '700px' : '280px'}
          billingDetails={billingDetails}
          affiliateIdentifier={props.affiliateIdentifier}
          affiliateId={props.affiliateId}
          withStripe={true}
          disableSubmit={hideSubmitButton}
          locale={I18n.locale}
        />
      </div>
    );
  }

  return <>{content}</>;
};

AddNewCreditCard.propTypes = {
  fetchCreditCards: PropTypes.func.isRequired,
  affiliateIdentifier: PropTypes.string.isRequired,
  affiliateId: PropTypes.number.isRequired,
  ccvUrl: PropTypes.string.isRequired,
  ccvPublicToken: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default AddNewCreditCard;
